require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-eventi-larchitettura-scolastica-nel-cantone-ticino-1945-1980.json") })
        }
      }, "path---en-eventi-larchitettura-scolastica-nel-cantone-ticino-1945-1980");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-eventi-larchitettura-scolastica-nel-cantone-ticino-1945-1980!./.cache/json/en-eventi-larchitettura-scolastica-nel-cantone-ticino-1945-1980.json
// module id = 568
// module chunks = 231608221292675